module.exports = __webpack_public_path__ + "media/images/masks/avatar-status-1c606666e930a94a73e4c3b7e81a5588.svg";